<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col md="12" xl="12" lg="12" sm="12">
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <v-container fluid>
                <v-row no-gutters>
                  <v-col cols="3">
                  </v-col>
                  <v-col cols="2"></v-col>
                  <v-col cols="6">
                    <p v-show="smsText" style="color:#1976d2">{{smsText}}</p>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="1" align-self="center">
                    <v-btn @click="wyszukiwanie_wizyt_popup=true"><v-icon small>fa-search</v-icon></v-btn>
                  </v-col>
                  <v-col cols="12" sm="12" lg="2" md="2"  v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)">
                    <v-select v-if="(dostepnePlacowki != null && dostepnePlacowki.length > 0)" placeholder="Wybierz placówkę..." label="Placówka" :items="dostepnePlacowki" return-object v-model="wybranaPlacowka" item-text="name"></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" lg="2" md="2" align-self="center" class="ml-10" v-if="dostepneKategorie && dostepneKategorie.length > 0">
                    <v-select placeholder="Wybierz zabieg..." :items="dostepneKategorie" return-object v-model="wybranaKategoria" clearable item-text="nazwa">
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <ejs-schedule height="auto" :startHour="startHour" :endHour="endHour" width="100%" id="Schedule"
                            :eventSettings='eventSettings' :timeScale="timeScale" :workHours="workHours" :rowAutoHeight="true"  @dataBinding="createScheduler"
                            :popupOpen='onPopupOpen' :firstDayOfWeek="firstDayOfWeek" :eventRendered="oneventRendered" :ownerCollections="zabiegiList" :actionBegin="beginAction"  :currentView="currentView"
                            :group="group" cssClass="poko-calendar" @navigating="navigating" @actionComplete="actionComplete"  :resourceHeaderTemplate='resourceTemplate'
                            ref="ScheduleObj">
                <e-views>
                  <e-view option="Day" :eventTemplate="dayTemplate"></e-view>
                  <e-view option="Week" :eventTemplate="dayTemplate"></e-view>
                  <e-view option="Month"></e-view>
                </e-views>
                <e-resources>
                  <e-resource field="zabiegID" title="Zabiegi" :dataSource='zabiegiList' allowMultiple="true"
                              name="Zabiegi" textField="nazwa" idField="id" colorField="kolor">
                  </e-resource>
                </e-resources>
              </ejs-schedule>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <VisitEditor  v-if="showVisitEditor" :visible="showVisitEditor" :visitData="visitData" :zabieg="true" :zabiegi="fullZabiegiList" @close="closeAddPopup" :placowka="wybranaPlacowka"/>
    <v-dialog v-model="wyszukiwanie_wizyt_popup" transition="dialog-bottom-transition" persistent width="80%">
      <v-card>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-tabs
                    grow
                    v-model="active_tab_visits"
                    slider-color="primary"
                >
                  <v-tab ripple key="0"><v-icon small>fas fa-search</v-icon>Wyszukiwanie wizyt</v-tab>
                  <v-tab-item key="0">
                    <v-card>
                      <v-card-text>
                        <v-container fluid>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-autocomplete
                                  v-model="searchClientId"
                                  :loading="isLoadingClients"
                                  :items="clientsList"
                                  :search-input.sync="clientKeyword"
                                  cache-items
                                  flat
                                  no-data-text="Nieznaleziono"
                                  hide-details
                                  clearable
                                  item-text="name"
                                  item-value="id"
                                  prepend-icon="fa-search"
                                  label="Wyszukaj pacjenta Imię/Nazwisko/PESEL"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-autocomplete
                                  v-model="searchTherapistId" :loading="isLoadingTherapists" :items="therapists"
                                  :search-input.sync="therapistKeyword" cache-items flat clearable
                                  no-data-text="Nieznaleziono" hide-details
                                  item-text="name" item-value="id"
                                  prepend-icon="fa-search"
                                  label="Wyszukaj terapeute Imię/Nazwisko"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-form>
                                <v-container fluid>
                                  <v-row no-gutters>
                                    <v-col cols="6">
                                      <v-menu
                                          v-model="showSearchDate1"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          :disabled="searchOnlyIncomming"
                                          transition="scale-transition"
                                          offset-y
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                              v-model="searchDate1"
                                              label="Data początkowa"
                                              prepend-icon="fa-calendar-alt"
                                              placeholder="Wybierz date"
                                              readonly
                                              v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="searchDate1" @input="showSearchDate1 = false" :disabled="searchOnlyIncomming"  no-title scrollable locale="pl-PL"></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                      <v-menu
                                          v-model="showSearchDate2"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          :disabled="searchOnlyIncomming"
                                          transition="scale-transition"
                                          offset-y
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                              v-model="searchDate2"
                                              label="Data końcowa"
                                              prepend-icon="fa-calendar-alt"
                                              placeholder="Wybierz date"
                                              readonly
                                              v-on="on"
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="searchDate2"  @input="showSearchDate2 = false" :disabled="searchOnlyIncomming"  no-title scrollable locale="pl-PL"></v-date-picker>
                                      </v-menu>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                    <v-col cols="12">
                                      <v-checkbox
                                          v-model="searchOnlyIncomming"
                                          label="Tylko nadchodzące wizyty?"
                                      ></v-checkbox>
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters v-show="searchResultsVisible">
                                    <v-col cols="12">
                                      <v-data-table
                                          :options.sync="pagination"
                                          :items="searchItems"
                                          :loading="searchLoading"
                                          :server-items-length="searchTotalResults"
                                          :no-results-text="noResults"
                                          :no-data-text="noResults"
                                          :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
                                          :headers="headers">
                                        <template v-slot:item.startTime="{item}">
                                          {{ getFormattedDate(item.startTime) }}
                                        </template>
                                        <template v-slot:item.endTime="{item}">
                                          {{ getFormattedDate(item.endTime) }}
                                        </template>
                                        <template v-slot:item.status="{item}">
                                          {{ getStatusDescription(item.status) }}
                                        </template>
                                        <template v-slot:item.id="{item}">
                                          <v-icon small class="mr-2" @click="showEditPopup(item.id)" title="Edytuj wizyte">fa-user-edit</v-icon>
                                        </template>
                                      </v-data-table>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-form>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="resetSearch" color="primary">Reset</v-btn>
                        <v-btn color="success" @click="handleSearch">Szukaj</v-btn>
                        <v-btn color="error" @click="wyszukiwanie_wizyt_popup = false">Zamknij</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { clientService } from "@/services/";
import { visitService } from "@/services/";
import { therapistsService } from "@/services/";
import Vue from 'vue'

import {DataManager, UrlAdaptor } from "@syncfusion/ej2-data";
import { Day, Week, Month } from "@syncfusion/ej2-vue-schedule";
import { DatePickerPlugin} from '@syncfusion/ej2-vue-calendars';
import { authHeader } from "@/helpers";
import { ability } from "@/store/ability";
import * as dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import * as helpers from "@/helpers";
import VisitEditor from "./VisitEditor";
import {settingsService, zabiegiService} from "@/services";

class CustomAdaptor extends UrlAdaptor {
  processResponse(data, ds, query, xhr, request, changes) {
    let processedData = [];
    if(changes)

    if (data != null && data.result != null && data.result.items != null) {
      data.result.items.forEach(item => {
        processedData.push({
          Id: item.id,
          Subject: item.clientName,
          StartTime: item.startTime,
          EndTime: item.endTime,
          CategoryColor: item.therapistColor,
          Description: item.therapistName,
          therapistID: item.therapistID,
          State: item.status
        });
      });
      this.receivedData(data.result.items);
    }

    return processedData;
  }
  processQuery(dm, query, hierarchyFilters) {

    var original = UrlAdaptor.prototype.processQuery;

    let query2 = original.apply(this, [dm, query, hierarchyFilters]);

    return query2;
  }
  beforeSend(dm, request) {

    request.setRequestHeader("Authorization", authHeader().Authorization);
  }
  receivedData() {}
}
var dataManger = new DataManager({
  url: helpers.apiConfig.apiUrl + "/api/services/app/Visit/ListVisits",
  adaptor: new CustomAdaptor(),
  crossDomain: false
});
Vue.use(DatePickerPlugin);
var dayTempVue = Vue.component("dayTemp", {
  template: '<div class="template-wrapper" :style="{background: data.PrimaryColor}">'+
      '<div class="subject" :style="{background: data.SecondaryColor, borderColor: data.PrimaryColor}">{{data.Subject}} -  {{getTimeString(data.StartTime)}} - {{getTimeString(data.EndTime)}}</br>{{data.therapistSurname}}</div></div>',
  data() {
    return {
      data: {}
    };
  },
  methods: {
    getTimeString: function (value) {
      let dj = dayjs(value)
      return dj.format('HH:mm')
    }
  }
});
var terapeutaVue = Vue.component('terapeutaKalendarzVuew', {
  template: '<div class="template-wrapper" :style="{background: data.resourceData.kolor}">'+
      '<div style="text-align: center;color:white;padding:5px">{{data.resourceData.nazwa}}</div></div>',
  data() {
    return {
      data: {}
    }
  },
});
export default {
  name: "VisitsZabiegi",
  data() {
    return {
      startHour: "06:00",
      endHour: "22:00",
      workHours: {
        highlight: false,
        start: "06:00",
        end: "22:00"
      },
      fullZabiegiList: [],
      currentView: 'Day',
      firstDayOfWeek: 1,
      //datamanager
      eventSettings: { dataSource: [] },
      unsubscribeEvent: null,
      visitData: null,
      showVisitEditor: false,
      therapistsList: [],
      localTherapistsList: [],
      fullEventData: [],
      nearVisits: [],
      currentVisits: [],
      kategorieList: [],
      zabiegiList: [],
      initialDataLoaded: false,
      wybranaKategoria: null,
      pastVisits: [],
      timerNear: 0,
      timerVisits: 0,
      firstRefresh: false,
      refreshing: false,
      wybranaPlacowka: null,
      active_tab_visits: 0,
      searchClientId: 0,
      isLoadingClients: false,
      clientsList: [],
      searchTherapistId: 0,
      isLoadingTherapists: false,
      therapists: [],
      clientKeyword: null,
      therapistKeyword: null,
      showSearchDate1: false,
      showSearchDate2: false,
      searchDate1: null,
      searchDate2: null,
      wyszukiwanie_wizyt_popup: false,
      searchOnlyIncomming: false,
      searchResultsVisible: false,
      searchTotalResults: 0,
      searchLoading: true,
      searchItems: [],
      noResults: "Nie znaleziono danych",
      pagination: {},
      orgPagination: null,
      initialLoad: false,
      headers: [
        { text: 'Pacjent', sortable: false, align: 'left', value: 'clientName'},
        { text: 'Terapeuta', sortable: false, align: 'left', value: 'therapistName'},
        { text: 'Początek', sortable: false, align: 'left', value: 'startTime'},
        { text: 'Koniec', sortable: false, align: 'left', value: 'endTime'},
        { text: 'Status', sortable: false, align: 'left', value: 'status'},
        { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      dayTemplate: function () {
        return {
          template: dayTempVue
        };
      },
      slotCount: 2,
      timeScale: {
        enable: true,
        interval: 60,
        slotCount: 2,
        majorSlotTemplate: null,
        minorSlotTemplate: null
      },
      slotsNumbers: [2,4,6],
      smsText: '',
      lastTimeCheckedSMS: null,
      group_therapist: false,
      calCurrentView: '',
      group: { byGroupID: false, resources: [] },
      resourceTemplate: function () {
        return { template: terapeutaVue }
      },
      wybranyTerapeuta: null,
      pokazuj_wszystkich: false
    };

  },
  computed: {
    ...mapState("visits", ["noBlinkVisits"]),
    ...mapState('featuresModule',['features']),
    ...mapState('companySettingsModule',['settings']),
    isSmsEnabled: function() {
      return this.features && this.features.SendSMS
    },
    dostepneKategorie: function() {
      if(!this.kategorieList || this.kategorieList.length == 0)
        return null

      if(this.wybranaPlacowka != null)
      {
        let kategorieDlaPLacowki = []
        this.fullZabiegiList.forEach(elem => {
          if(elem.additionalOutpostId == this.wybranaPlacowka.id)
            kategorieDlaPLacowki.push(elem.kategoriaId)
        })
        let kat =  this.kategorieList.filter(x => kategorieDlaPLacowki.indexOf(x.id) >= 0)
        return kat
      }
      else
      {
        return this.kategorieList
      }
    },
    dostepnePlacowki: function() {
      let placowki = []

      let userDetails = this.$store.state.account.userdetails

      if(this.settings.additionalOutposts && this.settings.additionalOutposts.length > 0)
      {
        this.settings.additionalOutposts.forEach(elem => {
          if(userDetails != null && userDetails.additionalOutposts && (userDetails.additionalOutposts.length == 0 || userDetails.additionalOutposts.indexOf(elem.id) != -1))
            placowki.push(elem)
        })
      }
      return placowki
    },
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),
    ...mapActions("visits", ["saveNoBlinkVisits"]),
    PokazujWszystkichPracownikow() {

      this.pokazuj_wszystkich = !this.pokazuj_wszystkich
      if(this.calCurrentView == 'Day')
      {
        this.refreshData()
      }
    },
    beginAction(args) {

    },
    actionComplete(args) {

      if(args.requestType && args.requestType == 'viewNavigate')
      {
        this.refreshData()
      }
      if(args.requestType && args.requestType == 'dateNavigate')
      {
        this.refreshData()
      }
    },
    createScheduler()
    {
      if(!this.initialLoad)
      {
        this.initialLoad = true
        this.refreshData()
        return
      }
      //console.log(args)
      //
      //this.eventSettings = {dataSource: [] }
    },
    onPopupOpen(args) {
      this.ShowPopup(args.data);
      args.cancel = true;
    },
    ShowPopup(data) {
      /*  let fn = this.$store.subscribe((mutation, state) => {
          /*console.log(mutation.payload);*/
      /*});
      this.unsubscribeEvent = fn;*/
      this.visitData = data;
      this.showVisitEditor = true;
    },
    showEditPopup(id) {
      this.ShowPopup({ Id: id });
    },
    resetSearch() {
      this.searchClientId = 0
      this.searchTherapistId = 0
      this.searchLoading = false
      this.searchDate1 = null
      this.searchDate2 = null
      this.pagination = {}
      this.searchItems = []
      this.searchOnlyIncomming = false
      this.searchTotalResults = 0
      this.searchResultsVisible = false
      this.pagination = {...this.orgPagination}
      this.active_tab_visits = 0
      this.refreshData()
    },
    getFormattedDate(val)
    {
      let dj = dayjs(val)
      if(dj != null)
      {
        return dj.format("DD-MM-YYYY HH:mm")
      }
      else
      {
        return val
      }
    },
    getStatusDescription(status)
    {
      switch(status)
      {
        case 0:
          return 'Nowa'
        case 1:
          return 'Potwierdzona'
        case 2:
          return 'Anulowana'
        case 3:
          return 'Zakończona'
        default:
          return ''
      }
    },
    handleSearch() {
      /*   if(!this.searchDate1 && !this.searchDate2 && !this.searchOnlyIncomming)
         {
           this.error('Nie wybrano przedziału dat.')
           return
         }*/
      this.getSearchVisits()
    },
    refreshPastVisits() {
      visitService
          .GetPastVisits()
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.pastVisits = [];
              resp.data.result.items.forEach(itm => {
                let djStart = dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                this.pastVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: false,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania przeszłych wizyt");
          });
    },
    refreshBlinkClasses() {
      let scheduleObj = this.$refs.ScheduleObj;
      let allEvents = scheduleObj.getEvents();
      allEvents.forEach(event => {
        var elems = document.querySelectorAll(
            '[data-id="Appointment_' + event.Id + '"]'
        );
        if (elems != null && elems.length > 0) {
          let nv = this.currentVisits.find(x => x.id == event.Id);
          if (nv != null && nv.blink) elems[0].classList.add("blink_me");
          else elems[0].classList.remove("blink_me");
        }
      });
    },
    refreshCurrentVisits() {
      visitService
          .GetCurrentVisits()
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.currentVisits = [];
              let localNoBlink = [...this.noBlinkVisits];
              resp.data.result.items.forEach(itm => {
                let djStart = dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                let blink = !localNoBlink.find(x => x == itm.id);
                this.currentVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: blink,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });
              this.refreshBlinkClasses();
              this.clearBlinkStore();
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania bieżących wizyt");
          });
    },
    refreshNearVisits() {
      if (this.refreshing) return;
      this.refreshing = true;
      visitService
          .GetNearVisits(8)
          .then(resp => {
            if (
                resp.data != null &&
                resp.data.result != null &&
                resp.data.result.items != null
            ) {
              //this.nearVistists = resp.data.result.items
              this.nearVisits = [];
              resp.data.result.items.forEach(itm => {
                let djStart =
                    dayjs(itm.startTime);
                let djEnd = dayjs(itm.endTime);
                this.nearVisits.push({
                  therapistColor: itm.therapistColor,
                  therapistName: itm.therapistName,
                  clientName: itm.clientName,
                  id: itm.id,
                  blink: false,
                  hours: djStart.format("HH:mm") + " - " + djEnd.format("HH:mm")
                });
              });

              this.refreshing = false;
              this.refreshCurrentVisits();
              this.refreshPastVisits();
            }
          })
          .catch(e => {
            console.log(e)
            this.error("Błąd pobierania najbliższych wizyt");
            this.refreshing = false;
          });
    },
    refreshData() {

      let dates = this.$refs.ScheduleObj.ej2Instances.getCurrentViewDates()

      let startDate = dates[0]
      let endDate = dates.length > 1 ?  dates[dates.length - 1] : dates[0]
      let data = {
        startDate: dayjs(startDate).format('DD-MM-YYYY'),
        endDate: dayjs(endDate).format('DD-MM-YYYY'),
        zabiegi: true,
        placowkaId: this.wybranaPlacowka ? this.wybranaPlacowka.id : 0
      }

  /*    if(this.wybranyTerapeuta && this.wybranyTerapeuta.userId > 0)
      {
        data['therapistID'] = this.wybranyTerapeuta.userId
      }*/
      visitService.listVisits(data).then(results => {
        if(results.data && results.data.result && results.data.result.items)
        {
          let processedData = [];
          results.data.result.items.forEach(item=> {
            processedData.push({
              Id: item.id,
              Subject: item.clientName,
              StartTime: item.startTime,
              EndTime: item.endTime,
              CategoryColor: item.therapistColor,
              Description: item.therapistName,
              therapistID: item.therapistID,
              State: item.status,
              therapistSurname: item.therapistSurname,
              zabiegID: item.zabiegID
            });
          })

          this.handleSuccessData(results.data.result.items)
          this.eventSettings = { dataSource: processedData }
        }
      }).catch(() => {
        this.error("Błąd pobierania wizyt")
      })

      this.updateSmsStatus()
    },
    closeAddPopup() {
      //this.unsubscribeEvent();
      this.visitData = null;
      this.showVisitEditor = false;
      if(this.searchResultsVisible)
      {
        this.getSearchVisits()
      }
      else
      {
        this.refreshData();
        //this.refreshNearVisits();
      }
    },
    addCloseStyles(elem){

      /*let img = `linear-gradient(45deg, ${color} 33.33%, #e4edf2 33.33%, #e4edf2 50%, ${color} 50%, ${color} 83.33%, #e4edf2 83.33%, #ie4edf2 100%)`
      elem.style.backgroundImage = img
      elem.style.backgroundSize = "21.21px 21.21px"
      elem.style.color = "black"
      elem.style.fontWeight = "bold"*/
      elem.style.opacity = 0.3;
    },
    addConfirmedStyles(elem)
    {
      elem.classList.add("confirmed-icon")
    },
    addCanceledByUserStyles(elem)
    {
      elem.classList.add("canceledbyuser-icon")
    },
    addUnknownResponseStyles(elem)
    {
      elem.classList.add("wrongsmsanswer-icon")
    },
    clearCloseStyles(id)
    {
      let elems = document.querySelectorAll(
          '[data-id="Appointment_' + id + '"]'
      );
      if (elems != null && elems.length > 0)
      {
        //    elems[0].style.display = "block";
        elems[0].style.opacity = 1.0;
      }
    },
    noBlinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = false;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    blinkVisit(visitid) {
      let visit = this.currentVisits.find(x => x.id == visitid);
      if (visit != null) {
        visit.blink = true;

        let localArray = [...this.noBlinkVisits];
        if (!localArray.find(x => x == visitid)) localArray.push(visitid);

        this.saveNoBlinkVisits(localArray);
        this.refreshBlinkClasses();
      }
    },
    clearBlinkStore() {
      let localArray = [...this.noBlinkVisits];
      let newArray = [];
      localArray.forEach(x => {
        if (this.currentVisits.find(x => x.id == x)) newArray.push(x);
      });
      this.saveNoBlinkVisits(newArray);
    },
    oneventRendered: function(args) {
      if (
          args != null &&
          args.data != null &&
          args.data.therapistID != null &&
          args.data.therapistID > 0
      ) {
        /* let t = this.localTherapistsList.find(
             x => x.therapistID == args.data.therapistID
         );
         if (t != null && t.checked == false) {
           args.element.style.display = "none";
         }
         else
         {*/
        if(args.data.State == 3)
        {

          this.addCloseStyles(args.element,args.data.CategoryColor)
        }
        if(args.data.State == 1)
        {
          this.addConfirmedStyles(args.element)
        }
        if(args.data.State == 4)
        {
          this.addCanceledByUserStyles(args.element)
        }
        if(args.data.State == 5)
        {
          this.addUnknownResponseStyles(args.element)
        }
        //}
      }
    },
    onChangeResourceVisibility() {
      /*let scheduleObj = this.$refs.ScheduleObj;
      let allEvents = scheduleObj.getEvents();

      this.localTherapistsList.forEach(item => {
        var foundEvents = allEvents.filter(x => {
          if (x.therapistID == item.therapistID) {
            return x;
          }
        });

        if (!item.checked) {
          foundEvents.forEach(x => {
            var elems = document.querySelectorAll(
                '[data-id="Appointment_' + x.Id + '"]'
            );
            if (elems != null && elems.length > 0)
              elems[0].style.display = "none";
          });
        } else {
          foundEvents.forEach(x => {
            var elems = document.querySelectorAll(
                '[data-id="Appointment_' + x.Id + '"]'
            );
            if (elems != null && elems.length > 0)
              elems[0].style.display = "block";
          });
        }
      });*/
    },

    handleSuccessData(args) {
      if(this.wybranaPlacowka)
      {

        this.zabiegiList = this.fullZabiegiList.filter(elem=>elem.additionalOutposts != null && elem.additionalOutposts.indexOf(this.wybranaPlacowka.id) >= 0)
        if (this.wybranaKategoria != null && this.wybranaKategoria.id > 0) {
          this.zabiegiList = this.zabiegiList.filter(elem => elem.kategoriaId == this.wybranaKategoria.id)
        }
      }
      else {
        if (this.wybranaKategoria != null && this.wybranaKategoria.id > 0) {
          this.zabiegiList = this.fullZabiegiList.filter(elem => elem.kategoriaId == this.wybranaKategoria.id)
          return;
        } else {
          this.zabiegiList = this.fullZabiegiList
        }
      }
    },
    getClientValues(val) {
      this.isLoadingClients = true;
      clientService
          .getAll({ query: val, page: 1, limit: 20, sorting: "surname" })
          .then(data => {
            data.data.result.items.forEach(item => {
              if (!this.clientsList.find(x => x.id === item.id)) {
                let name = item.name + " " + item.surname;
                if (item.pesel != null && item.pesel != "")
                  name = name + "/" + item.pesel;
                this.clientsList.push({
                  id: item.id,
                  name: name,
                  therapist: item.therapistID
                });
              }
            });

            this.isLoadingClients = false;
          })
          .catch(e => {
            console.log(e)
            this.isLoadingClients = false;
            this.error("Nie można pobrać listy klientów.");
          });
    },
    getAllZabiegi() {
      zabiegiService
          .getZabiegiList()
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null
            ) {
              this.fullZabiegiList = response.data.result
              this.kategorieList = []
              let kategorie = []
              this.fullZabiegiList.forEach(elem => {
              if(elem.kategoriaId && elem.kategoriaId > 0) {

                  let kategoria = {id: elem.kategoriaId, nazwa: elem.kategoriaNazwa};
                  let exist = this.kategorieList.find(x=>x.id == kategoria.id)
                  if(!exist)
                  {
                      kategorie.push(kategoria)
                  }
                }
              })
              this.kategorieList = kategorie
              if(kategorie && kategorie.length > 0)
              {
                this.wybranaKategoria = this.kategorieList[0]
              }
            } else {
              throw "error pobierania zabiegów";
            }
          })
          .catch(e => {
            console.log(e)
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy zabiegów.");
          });
    },
    loadTherapists(val) {
      this.isLoadingTherapists = true;
      therapistsService
          .getAll({ query: val, page: 1, limit: 10 })
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {
              response.data.result.items.forEach(r => {

                if (!this.therapists.find(x => x.id === r.id))
                  this.therapists.push({
                    id: r.id,
                    name: r.name + " " + r.surname,
                    pay: r.rate
                  });
              });
              this.isLoadingTherapists = false;
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(e => {
            console.log(e)
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy terapeutów.");
          });
    },
    updateSmsStatus(){
      if(this.isSmsEnabled && ability.can('do','POKO_InformacjeSMS'))
      {
        visitService.GetSMSDailyStatus().then(resp=> {
          if(resp.data != null && resp.data.result != null)
          {
            //console.log(resp.data.result)
            //this.lastTimeCheckedSMS =
            var day = new dayjs(resp.data.result.forDay)
            this.smsText =  'Ilość smsów na dzień '+day.format('DD-MM-YYYY')+': '+resp.data.result.smsSent+'/'+resp.data.result.smsTotal
          }
        })
      }
    },
    navigating(args)
    {

      //scheduleObj.dataModule.query.params
      let scheduleObj = document.getElementById("Schedule").ej2_instances[0];
      if(args && args.action == 'view') {

        if (args && args.currentView === 'Day') {
          this.calCurrentView = 'Day'
          scheduleObj.group.resources = ["Zabiegi"];
          //this.refreshData()
          //console.log('day')
        } else {
          this.calCurrentView = args.currentView
          scheduleObj.group.resources = [];
          //this.refreshData()
          //console.log('other')

        }
      }
    },
    getSearchVisits() {
      const { sortBy, sortDesc, page, itemsPerPage  } = this.pagination
      let sortValue = ''
      if(sortBy.length > 0)
      {
        sortValue = sortBy[0]
        if(sortDesc.length > 0)
          sortValue = sortBy[0] + ( sortDesc[0] ? " DESC": "");
      }
      this.searchResultsVisible = true
      this.searchLoading = true
      var data = {}
      data.SkipCount = (page - 1) * itemsPerPage
      data.MaxResultCount = itemsPerPage
      data.Sorting = sortValue
      if(this.searchClientId > 0)
      {
        data.clientID = this.searchClientId
      }
      if(this.searchTherapistId > 0)
      {
        data.therapistID = this.searchTherapistId
      }
      if(this.searchOnlyIncomming)
      {
        data.showOnlyIncommingVisits = true
      }
      else
      {
        data.startDate = this.searchDate1
        data.endDate = this.searchDate2
      }
      visitService.ListPaginatedVisits(data).then(resp => {
        if(resp.data != null && resp.data.result != null)
        {
          this.searchItems = resp.data.result.items,
              this.searchTotalResults = resp.data.result.totalCount
        }
        this.searchLoading = false
      }).catch(e => {
        console.log(e)
        this.error("Błąd wyszukiwania wizyt")
        this.searchLoading = false
      })


    }
  },
  created() {
    this.updateTitle("Wizyty");
    this.getAllZabiegi()
    //this.eventSettings.dataSource.adaptor.receivedData = this.handleSuccessData;
    this.updateSmsStatus()


  },
  components: {
    VisitEditor
  },
  provide: {
    schedule: [Day, Week, Month]
  },
  mounted() {

    let scheduleObj = document.getElementById("Schedule").ej2_instances[0];
    if(this.currentView == 'Day')
    {
      scheduleObj.group.resources = ["Zabiegi"];
    }

    this.timerVisits = setInterval(this.refreshData.bind(this), 5 * 60 * 1000); //odswiezamy dane co 5 min
    //this.timerNear = setInterval(this.refreshNearVisits.bind(this), 60 * 2000); //odswiezamy najblizsze wizyty co 2 min
    Vue.prototype.$timerVisits = this.timerVisits
    //Vue.prototype.$timerNear = this.timerNear
    dayjs.extend(customParseFormat);
    dayjs.extend(isSameOrAfter);
    settingsService.GetCompanySettings().then(success=> {
      if(success.data.result)
      {
        let data = success.data.result
        if(data.id > 0)
        {
          if(data.godzina_otwarcia_start)
          {
            this.startHour = dayjs(data.godzina_otwarcia_start).format('HH:mm')
          }
          if(data.godzina_otwarcia_koniec)
          {
            this.endHour = dayjs(data.godzina_otwarcia_koniec).format('HH:mm')
          }
        }
      }
    }).catch(() => {
      this.error('Bład pobierania ustawień firmy')
    })
    if(this.dostepnePlacowki && this.dostepnePlacowki.length > 0)
    {
      this.wybranaPlacowka = this.dostepnePlacowki[0]
    }
    //let startDate = currentViewDates[0]
    //let endDate = currentViewDates[currentViewDates.length - 1]
    //console.log(startDate);
    //console.log(endDate);
  },
  beforeDestroy() {
    clearInterval(this.timerVisits);
    //clearInterval(this.timerNear);
  },
  watch: {
    wybranaPlacowka() {
      this.refreshData()
    },
    dostepneKategorie() {
      if(this.wybranaKategoria != null && this.dostepneKategorie.length > 0 && !this.dostepneKategorie.find(x=>x.id == this.wybranaKategoria.id))
      {
        this.wybranaKategoria = this.dostepneKategorie[0]
      }
    },
    wybranaKategoria(val)
    {
      this.refreshData()
    },
    slotCount(val)
    {
      this.timeScale = {    enable: true,
        interval: 60,
        slotCount: val,
        majorSlotTemplate: null,
        minorSlotTemplate: null
      }
    },
    clientKeyword(val) {
      if (val) {
        this.getClientValues(val);
      }
    },
    therapistKeyword(val) {
      if (val) {
        this.loadTherapists(val);
      }
    },
    searchOnlyIncomming(val) {
      if(val)
      {
        this.searchDate1 = null
        this.searchDate2 = null
      }
    },
    wybranyTerapeuta() {
      /*let scheduleObj = document.getElementById("Schedule").ej2_instances[0];
      if(val)
      {
//        let data = { key: "TherapistID", value: val.userId};
        //data.TherapistID = val.userId


      }
      else
      {
        if(scheduleObj.dataModule.query.params.length > 0)
        {
        //  scheduleObj.dataModule.query.params = []
//          scheduleObj.dataBind()
        }
      }*/
      this.refreshData()
    },
    pagination: {
      handler() {
        if(this.orgPagination == null)
          this.orgPagination = {...this.pagination}
        if(this.searchResultsVisible)
          this.getSearchVisits()
      },
      deep: true
    }
  }
};
</script>

<style>

.visits .e-schedule table.e-schedule-table td {
  padding: initial;
}
.poko-.e-schedule.e-device .e-resource-tree-popup .e-fullrow {
  height: 50px;
}
</style>
